<template>
  <group-details
    :id="orgId"
    :display-key-owner="false"
    :display-seats="false"
    seat-edit-mode="REQUEST"
  />
</template>

<script>
import GroupDetails from '../../../components/access/GroupDetails';

export default {
  name: 'org-users',
  components: {
    GroupDetails,
  },
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  computed: {
    orgId() {
      const groups = this.user['https://vrpatients.com/groups'];
      if (!groups) {
        return null;
      }
      return groups[0];
    }
  },
  created() {
    if (this.$route.meta.archived) {
      this.$analytics.event('Org Management', 'grading_archive_page');
    } else if (this.$route.meta.subscribed) {
      this.$analytics.event('Org Management', 'subscribed_user_page');
    } else {
      this.$analytics.event('Org Management', 'user_page');
    }
  }
};
</script>

<style scoped>
</style>